import React, { Component } from 'react';
import { connect } from 'react-redux';
import { map, max } from 'lodash';
import Widget from '../Widget';
import { formatMoney } from '../../../../constants/utils';
import {
    getTotalpurchaseYTDByPP,
    pushReferrer,
} from '../../../../redux/actions';
import NoItems from '../../../../components/NoItems';

import './styles.css';
import ErrorPage from '../../../../components/ErrorPage/ErrorPage';
import { Icon } from 'semantic-ui-react';

export class TotalPurchaseYTDWidgetByPP extends Component {
    async componentDidMount() {
        await this.init();
    }

    init = async () => {
        const { getTotalpurchaseYTDByPP } = this.props;
        await getTotalpurchaseYTDByPP(this.props.retailerInfo?.reference);
    };

    async componentDidUpdate(prevProps, prevState) {
        if (this.props.retailerInfo !== prevProps.retailerInfo) {
            await this.init();
        }
    }

    renderWidgetBar = (max, value) => {
        return (
            <div
                className="total-percentage-bar text-right"
                style={{ width: `${(value / max) * 100}%`, minWidth: '7%' }}>
                <div className="bar-text">
                    <span>{value}</span>
                </div>
            </div>
        );
    };

    render() {
        const { loading, totalPurchaseYTDByPPs, errorResponse } = this.props;

        const noContent =
            !totalPurchaseYTDByPPs && totalPurchaseYTDByPPs?.length > 0;

        let maxTotal = 0;

        if (!noContent) {
            maxTotal = max(map(totalPurchaseYTDByPPs, 'itemCount'));
        }
        return (
            <Widget loading={loading} data-testid="totalPurchaseByPP">
                <div className="bold widget-heading">
                    Total Purchase YTD By Price Point
                    <div className="widget-title-refresh-button">
                        <Icon name="refresh" onClick={this.init} />
                    </div>
                </div>

                {!totalPurchaseYTDByPPs && errorResponse !== null ? (
                    <ErrorPage msg={errorResponse?.status} />
                ) : (totalPurchaseYTDByPPs && totalPurchaseYTDByPPs.length) >
                  0 ? (
                    <div
                        className="total-purchase-YTD-PP-widget-content widget-container-height"
                        data-testid="withData">
                        <table>
                            <tbody>
                                {map(
                                    totalPurchaseYTDByPPs,
                                    (TotalPurchaseYTD) => (
                                        <tr
                                            className="task-completion-bar"
                                            key={TotalPurchaseYTD.itemPrice}>
                                            <td>
                                                <div className="game-info">
                                                    <div className="bold price-point">
                                                        {formatMoney(
                                                            TotalPurchaseYTD.itemPrice,
                                                        )}
                                                    </div>

                                                    <div>
                                                        {this.renderWidgetBar(
                                                            maxTotal,
                                                            TotalPurchaseYTD.itemCount,
                                                        )}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ),
                                )}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <NoItems
                        messageClassName=""
                        style={{ marginTop: '37px', marginBottom: '30px' }}
                        message="There are no delivered order!"
                        data-testid="noData"
                    />
                )}
            </Widget>
        );
    }
}

const mapStateToProps = (state) => {
    const { loading, totalPurchaseYTDByPPs, errorResponse } =
        state.totalPurchaseYTDByPP;
    const { retailerInfo } = state.userInfo;
    return { loading, totalPurchaseYTDByPPs, retailerInfo, errorResponse };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setReferrer: (ref) => dispatch(pushReferrer(ref)),
        getTotalpurchaseYTDByPP: (retailerReference) =>
            dispatch(getTotalpurchaseYTDByPP(retailerReference)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TotalPurchaseYTDWidgetByPP);
